let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hPalR"), load("7AsyI")]).then(() => parcelRequire('480Js'));